import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { HeaderOriginationCloseButton } from './HeaderOriginationCloseButton.js';
import { Icon } from '../Icon/Icon.js';

var _excluded = ["bgSecondary", "buttonAttributes", "children", "className", "closeText", "hideClose", "href", "onClick", "fluid", "logo", "logoHref"];
var HeaderOrigination = props => {
  var {
      bgSecondary,
      buttonAttributes = {},
      children,
      className = '',
      closeText,
      hideClose,
      href,
      onClick,
      fluid,
      logo,
      logoHref
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  if (href === null && onClick === null) {
    props.hideClose = true; // eslint-disable-line 
  } else if (href) {
    buttonAttributes.href = href;
  } else if (onClick) {
    buttonAttributes.onClick = onClick;
  }
  var logoBlock = logo || /*#__PURE__*/React.createElement(Icon, {
    screenreader: "Commonwealth Bank logo",
    symbol: "logoCBASymbol40",
    href: logoHref,
    type: "css"
  });
  var classsNames = "".concat(className, " headerorigination ").concat(bgSecondary ? 'bg-lightsecondary' : 'bg-light').trim();
  var hcid = "".concat(HeaderOrigination.name.toLocaleLowerCase(), "-").concat("10.6.2");
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classsNames
  }, attributes, {
    "data-hcid": hcid
  }), /*#__PURE__*/React.createElement("div", {
    className: fluid ? 'container-fluid' : 'container'
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("header", {
    role: "banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerorigination-logo"
  }, logoBlock, children && children), !props.hideClose && /*#__PURE__*/React.createElement(HeaderOriginationCloseButton, _extends({
    closeText: closeText
  }, buttonAttributes)))))));
};
HeaderOrigination.defaultProps = {
  fluid: true,
  hideClose: false
};
HeaderOrigination.propTypes = {
  buttonAttributes: PropTypes.object,
  children: PropTypes.any,
  closeText: PropTypes.string,
  fluid: PropTypes.bool,
  href: PropTypes.string,
  logo: PropTypes.element,
  logoHref: PropTypes.string,
  onClick: PropTypes.func,
  // eslint-disable-next-line 
  typecheck: props => {
    if (props.href && props.onClick) {
      return new Error('The HeaderOrigination should not contain both a "href" and an "onClick" prop.');
    }
    if (!props.href && !props.onClick) {
      return new Error('The HeaderOrigination should contain "href" or "onClick" prop.');
    }
  }
};

export { HeaderOrigination };
